export const saveSynoTokenToSessionStorage = (synoToken) => {
  sessionStorage.removeItem('synoToken')

  if (synoToken) {
    sessionStorage.setItem('synoToken', synoToken)
  }
}

export const synoTokenFromSessionStorage = () => sessionStorage.getItem('synoToken')
